
<template>
    <div class="echartStyle" ref="chart" id="mychart"></div>
</template>

<script>
import * as echarts from 'echarts'
import xCircle from '../assets/xsymbol.svg'
export default {
  name: 'HelloWorld',
  props: {
    leftNum: {
      type: Array
    },
    rightNum: {
      type: Array
    },
    chartWidth: {
      type: Number
    },
    chartHeight: {
      type: Number
    }
  },
  data () {
    return {
      myChart: {},
      xData: ['', '125', '250', '500', '1000', '2000', '4000', '8000', ' '],
      dataValueLeft: this.leftNum,
      dataValueRight: this.rightNum,
      myChartStyle: {float: 'left', width: '484px', height: '613px'},
      chartInstance: null,
      screenWidth: window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
    }
  },
  mounted () {
    this.initEcharts()
    this.initChart()
    this.resizeChart()
    window.addEventListener('resize', this.resizeChart)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.resizeChart)
  },
  methods: {
    initChart () {
      this.chartInstance = echarts.init(this.$refs.chart)
    },
    resizeChart () {
      const screenWidth = document.body.clientWidth
      console.log('resize')
      if (screenWidth < 768) {
        this.chartInstance.resize({width: `${screenWidth * 1.0}`, height: '613px'})
      } else {
        this.chartInstance.resize({ width: '484px', height: '613px' })
      }
    },
    initEcharts () {
      const option = {
        title: {
          text: 'Frequency (Hz)',
          left: 'center'
        },
        xAxis: {
          boundaryGap: false,
          position: 'top',
          type: 'category',
          data: this.xData,
          axisLabel: {
            interval: 0// 设置为 0，强制显示所有标签
          },
          splitLine: { // 保留网格线
            show: true,
            lineStyle: {
              type: 'dashed',
              color: '#aeb0b7', // y线的颜色
              width: '1' // 坐标线的宽度
            }
          },
          axisTick: {
            show: false,
            length: 5,
            lineStyle: {
              color: '#000000',
              width: 4,
              type: 'solid'
            }
          }
        },
        yAxis: {
          data: this.yData,
          inverse: true,
          type: 'value',
          interval: 10, // 步长
          min: -10, // 起始
          max: 100, // 终止
          splitLine: { // 保留网格线
            show: true,
            lineStyle: {
              type: 'dashed',
              color: '#aeb0b7', // y线的颜色
              width: '1' // 坐标线的宽度
            }
          },
          axisTick: {
            show: false,
            length: 5,
            lineStyle: {
              color: '#000000',
              width: 4,
              type: 'solid'
            }
          }
        },
        series: [
          {
            type: 'custom',
            itemStyle: {
              normal: {
                // 设置不同颜色
                color: function (params) {
                  let color0 = ''
                  let color1 = ''
                  // if(params.dataIndex){
                  color0 = new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                    offset: 0,
                    color: 'rgba(198, 255, 221, 0.3)'
                  }, {
                    offset: 1,
                    color: 'rgba(251, 215, 134, 0.3)'
                  }])
                  color1 = new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                    offset: 0,
                    color: 'rgba(251, 215, 134, 0.3)'
                  }, {
                    offset: 1,
                    color: 'rgba(247, 121, 125, 0.3)'
                  }])
                  // build a color map as your need.
                  let colorList = [color0, color1]
                  return colorList[params.dataIndex]
                }
              }
            },
            renderItem: function (params, api) {
              // 对于 data 中的每个 dataItem，都会调用这个 renderItem 函数。
              // （但是注意，并不一定是按照 data 的顺序调用）

              // 这里进行一些处理，例如，坐标转换。
              // 这里使用 api.value(0) 取出当前 dataItem 中第一个维度的数值。
              var x = api.value(0)
              var y = api.value(1)
              var width = api.value(2)
              var height = api.value(3)
              const screenWidth = document.body.clientWidth
              console.log('resize')
              if (screenWidth < 768) {
                x = screenWidth * 0.10
                y = api.value(1)
                width = screenWidth * 0.80
                height = api.value(3)
              }
              // 这里返回为这个 dataItem 构建的图形元素定义。
              return {
                // 表示这个图形元素是矩形。还可以是 'circle', 'sector', 'polygon' 等等。
                type: 'rect',
                // shape 属性描述了这个矩形的像素位置和大小。
                // 其中特殊得用到了 echarts.graphic.clipRectByRect，意思是，
                // 如果矩形超出了当前坐标系的包围盒，则剪裁这个矩形。
                shape: echarts.graphic.clipRectByRect({
                  // 矩形的位置和大小。
                  x: x,
                  y: y,
                  width: width,
                  height: height
                }, {
                  // 当前坐标系的包围盒。
                  x: x,
                  y: y,
                  width: width,
                  height: height
                }),
                // 用 api.style(...) 得到默认的样式设置。这个样式设置包含了
                // option 中 itemStyle 的配置和视觉映射得到的颜色。
                style: api.style()
              }
            },
            data: [
              [50, 60, 385, 350],
              [50, 410, 385, 135]
            ]
          },
          {
            data: this.dataValueLeft,
            type: 'line',
            itemStyle: {
              color: '#003399'
            },
            symbol: `image://${xCircle}`,
            symbolSize: 20,
            lineStyle: {
              width: 3,
              shadowOffsetX: 0, // 折线的X偏移
              shadowOffsetY: 9,
              shadowBlur: 8,
              shadowColor: 'rgba(145, 132, 132, 1)'
            }
          },
          {
            data: this.dataValueRight,
            type: 'line',
            itemStyle: {
              color: '#f64646'
            },
            symbol: 'circle',
            symbolSize: 20,
            lineStyle: {
              width: 3,
              shadowOffsetX: 0, // 折线的X偏移
              shadowOffsetY: 9,
              shadowBlur: 8,
              shadowColor: 'rgba(145, 132, 132, 1)'
            }
          }
        ],
        aria: {
          enabled: true,
          decal: {
            show: true
          }
        }
      }
      this.myChart = echarts.init(document.getElementById('mychart'))
      this.myChart.setOption(option)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.echartStyle{
  float: left;
  width: 484px;
  height: 613px;
}

@media (max-width: 768px) {
  .echartStyle{
    float: left;
    width: 100px;
    height: 613px;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue